/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithQuote_shoppingWith = {
    readonly quote: {
        readonly authorName: string | null;
        readonly image: string | null;
        readonly quoteBody: string | null;
    } | null;
    readonly " $refType": "ShoppingWithQuote_shoppingWith";
};
export type ShoppingWithQuote_shoppingWith$data = ShoppingWithQuote_shoppingWith;
export type ShoppingWithQuote_shoppingWith$key = {
    readonly " $data"?: ShoppingWithQuote_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithQuote_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithQuote_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quote",
      "storageKey": null,
      "args": null,
      "concreteType": "ShoppingWithQuote",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "authorName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "image",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quoteBody",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '0d85da2f98373cb8f13015826d36dc91';
export default node;
